import Axios from "axios";

declare let window: any;

// Configurações de Calendário
export const DISPLAY_FORMAT = 'L';
export const ISO_FORMAT = 'DD/MM/YYYY';
export const ISO_MONTH_FORMAT = 'MM/YYYY';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const HORIZONTAL_ORIENTATION = 'horizontal';
export const VERTICAL_ORIENTATION = 'vertical';
export const VERTICAL_SCROLLABLE = 'verticalScrollable';
export const ICON_BEFORE_POSITION = 'before';
export const ICON_AFTER_POSITION = 'after';
export const ANCHOR_LEFT = 'left';
export const ANCHOR_RIGHT = 'right';
export const OPEN_DOWN = 'down';
export const OPEN_UP = 'up';
export const DAY_SIZE = 39;
export const BLOCKED_MODIFIER = 'blocked';
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
export const FANG_WIDTH_PX = 20;
export const FANG_HEIGHT_PX = 10;
export const DEFAULT_VERTICAL_SPACING = 22;
export const MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
export const WEEKDAYS_SHORT = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
export const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];
export const MONTHS_SHORT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];
export const WEEKDAYS_LONG = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
];
export const FIRST_DAY_OF_WEEK = 0;
export const LABELS = {
  nextMonth: 'Próximo mês',
  previousMonth: 'Mês Anterior',
};

// configuracoes gerais
export const QUANTIDADE_PARCELAS = 6;
export const PROMOTION_HOTEL_DEADLINE = '2018-8-31';

export const IDADE_AEREO_FORM = {
  Adulto: 17,
  Criança: 2,
  Bebe: 2,
};

export const IDADES_AEREO = {
  adulto: 12,
  crianca: 2,
  bebe: 2,
};

export const UNDEFINED_OPTION = [{ label: 'UNDEFINED', value: '-01' }];

export const ESTADO_OPTIONS = [
  { label: 'AC', value: '01' },
  { label: 'AL', value: '11' },
  { label: 'AM', value: '06' },
  { label: 'AP', value: '05' },
  { label: 'CE', value: '13' },
  { label: 'BA', value: '12' },
  { label: 'DF', value: '27' },
  { label: 'GO', value: '02' },
  { label: 'ES', value: '20' },
  { label: 'MA', value: '14' },
  { label: 'MG', value: '21' },
  { label: 'MS', value: '04' },
  { label: 'MT', value: '03' },
  { label: 'PA', value: '07' },
  { label: 'PB', value: '15' },
  { label: 'PE', value: '16' },
  { label: 'PI', value: '17' },
  { label: 'PR', value: '24' },
  { label: 'RJ', value: '22' },
  { label: 'RN', value: '18' },
  { label: 'RO', value: '08' },
  { label: 'RR', value: '09' },
  { label: 'RS', value: '25' },
  { label: 'SC', value: '26' },
  { label: 'SE', value: '19' },
  { label: 'SP', value: '23' },
  { label: 'TO', value: '10' },
];

export const SEXO_OPTIONS = [
  { label: 'Masculino', value: 'masculino' },
  { label: 'Feminino', value: 'feminino' },
];

export const DOCUMENTO_OPTIONS_CHECKOUT = [
  { label: 'RG', value: 'RG' },
  { label: 'Passaporte', value: 'Passaporte' },
];

export const SEXO_OPTIONS_CREATE_ACCOUNT = [
  { label: 'Masculino', value: 'M' },
  { label: 'Feminino', value: 'F' },
];

export const DOCUMENTO_OPTIONS = [{ label: 'CPF', value: 'cpf' }];

export const PAIS_OPTIONS = [{ label: 'Brasil', value: '55' }];

export const TELEFONE_OPTIONS = [
  { label: 'Celular', value: 'celular' },
  { label: 'Residencial', value: 'residencial' },
];

export const HOUR_OPTIONS = [
  { label: '00:00', value: '00:00' },
  { label: '00:30', value: '00:30' },
  { label: '01:00', value: '01:00' },
  { label: '01:30', value: '01:30' },
  { label: '02:00', value: '02:00' },
  { label: '02:30', value: '02:30' },
  { label: '03:00', value: '03:00' },
  { label: '03:30', value: '03:30' },
  { label: '04:00', value: '04:00' },
  { label: '04:30', value: '04:30' },
  { label: '05:00', value: '05:00' },
  { label: '05:30', value: '05:30' },
  { label: '06:00', value: '06:00' },
  { label: '06:30', value: '06:30' },
  { label: '07:00', value: '07:00' },
  { label: '07:30', value: '07:30' },
  { label: '08:00', value: '08:00' },
  { label: '08:30', value: '08:30' },
  { label: '09:00', value: '09:00' },
  { label: '09:30', value: '09:30' },
  { label: '10:00', value: '10:00' },
  { label: '10:30', value: '10:30' },
  { label: '11:00', value: '11:00' },
  { label: '11:30', value: '11:30' },
  { label: '12:00', value: '12:00' },
  { label: '12:30', value: '12:30' },
  { label: '13:00', value: '13:00' },
  { label: '13:30', value: '13:30' },
  { label: '14:00', value: '14:00' },
  { label: '14:30', value: '14:30' },
  { label: '15:00', value: '15:00' },
  { label: '15:30', value: '15:30' },
  { label: '16:00', value: '16:00' },
  { label: '16:30', value: '16:30' },
  { label: '17:00', value: '17:00' },
  { label: '17:30', value: '17:30' },
  { label: '18:00', value: '18:00' },
  { label: '18:30', value: '18:30' },
  { label: '19:00', value: '19:00' },
  { label: '19:30', value: '19:30' },
  { label: '20:00', value: '20:00' },
  { label: '20:30', value: '20:30' },
  { label: '21:00', value: '21:00' },
  { label: '21:30', value: '21:30' },
  { label: '22:00', value: '22:00' },
  { label: '22:30', value: '22:30' },
  { label: '23:00', value: '23:00' },
  { label: '23:30', value: '23:30' },
];

export const sexoOption = [
  { title: 'Masculino', value: 'masculino' },
  { title: 'Feminino', value: 'feminino' },
];

export const documentoOption = [{ title: 'CPF', value: 'cpf' }];

export const paisOption = [{ title: 'Brasil', value: '55' }];

export const telefoneOption = [
  { title: 'Celular', value: 'celular' },
  { title: 'Residencial', value: 'residencial' },
];

export const nomesCompanias = [
  { title: 'LA', value: 'LATAM' },
  { title: 'JJ', value: 'LATAM' },
  { title: 'DL', value: 'DELTA' },
  { title: 'O6', value: 'AVIANCA' },
  { title: 'G3', value: 'GOL' },
  { title: 'AD', value: 'AZUL' },
  { title: 'TP', value: 'TAP AIR PORTUGAL' },
  { title: 'UX', value: 'AIR EUROPA' },
  { title: 'IB', value: 'IBERIA' },
  { title: 'AA', value: 'AmericanAirLines' },
];

export const SEGURO_DESTINOS = [
  {
    label: 'América Latina (Exceto Brasil)',
    type: 'america-latina-exceto-brasil',
    value: 1,
  },
  { label: 'Brasil', type: 'brasil', value: 2 },
  { label: 'Mundo (Exceto EUA)', type: 'mundo-exceto-eua', value: 4 },
  { label: 'Mundo (Incluindo EUA)', type: 'mundo-incluindo-eua', value: 5 },
];

export const SEGURO_CATEGORIA = [
  { label: 'Lazer / Negócios', type: 'lazer-negocios', value: 1 },
  { label: 'Intercâmbio', type: 'intercambio', value: 2 },
  { label: 'Multiviagens', type: 'multiviagens', value: 3 },
];

export const CODIGOCIDADE = 2717509;
export const PAGE_ID_FACEBOOK = '336583850083998';
export const RD_CODE = '01d8d996efdcccb98b5e12b7bd6e0c43';

// Codigos de operadora no aereo
// bancortur
// OPERADORA = 12;
// OPERADORA_COM_PROMO = 10;

// Voala
// OPERADORA = 19;
// OPERADORA_COM_PROMO = 18;

export const ID_OPERADORA = {
  comPromo: 18,
  semPromo: 19,
};

export const QUANTIDADE_DIAS_BLOQUEIO_PACOTE_E_HOSPEDAGEM = 0;

let apikeyGoogle = null;

function getEnvironmentMobile(environment: string): string {
  if (environment === 'prod-app') {
    return 'production';
  } else if (environment === 'homolog-app') {
    return 'homolog';
  } else {
    return environment;
  }
}

export const AMBIENTE_ATUAL = getEnvironmentMobile(process.env.REACT_APP_ENV);

export const IS_CORDOVA = window.cordova !== undefined;

let api_url_integracao_voala = null;
let url_base_voala = null;
let fingerPrint = null;
let api_url_aereo = null;

if (AMBIENTE_ATUAL === 'development') {
  api_url_aereo = "http://bbraswebhml01.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
  'http://bbraswebhml01.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://localhost:3000';
  apikeyGoogle = 'AIzaSyAoR17DGwAQ-I2lIy_Sc4cg7nfLnDUdT0g';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'local') {
  api_url_aereo = "http://bbraswebhml01.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala = 'http://localhost:33950/api/Voala/';
  url_base_voala = 'http://localhost:3000';
  apikeyGoogle = 'AIzaSyAoR17DGwAQ-I2lIy_Sc4cg7nfLnDUdT0g';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'test') {
  api_url_aereo = "http://bbraswebtst01.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebtst01.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-tst.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'test02') {
  api_url_aereo = "http://bbraswebtst02.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebtst02.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-tst02.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'test03') {
  api_url_aereo = "http://bbraswebtst03.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebtst03.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-tst03.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'test04') {
  api_url_aereo = "http://bbraswebtst04.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebtst04.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-tst04.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (process.env.REACT_APP_ENV === 'homolog-app') {
  api_url_aereo = "http://bbraswebclus03.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebclus03.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-hml.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'hml01') {
  api_url_aereo = "http://bbraswebhml01.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebhml01.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-hml.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'hml02') {
  api_url_aereo = "http://bbraswebhml02.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala =
    'http://bbraswebhml02.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'http://voala-hml02.bancorbras.com.br';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = '1snn5n9w';
} else if (AMBIENTE_ATUAL === 'production') {
  api_url_aereo = "https://www.bancorbras.com.br/webapi/gateway/voala/aereo/post/antifraude";
  api_url_integracao_voala = 'https://www.bancorbras.com.br/webapi/voala/api/Voala/';
  url_base_voala = 'https://www.vaidevoala.com.br';
  // apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  // apikeyGoogle = 'AIzaSyA7ZY2jjefMl6o1LM_k5y8C42siBUpqu-M';
  apikeyGoogle = 'AIzaSyALFmhceZ_zN0PvRkMODvpFLy8duks6zQA';
  fingerPrint = 'k8vif92e';
}

export const API_GOOGLE_GEOCODE_URL =
  'https://maps.googleapis.com/maps/api/geocode/';

export const API_URL_INTEGRACAO_VOALA = api_url_integracao_voala;

export const API_URL_GATEWAY_AEREO = api_url_aereo;

export const URL_BASE_VOALA = url_base_voala;

export const APIKEY_GOOGLE = apikeyGoogle;

export const DEVICE_FINGER_PRINT_ID = fingerPrint;

export const MAX_AGE_MENOR_IDADE = 11;

export const MIN_AGE_MENOR_IDADE = 2;

export const PRICE_OPTIONS = [
  { label: 'Preço: menor para o maior', value: 'price-asc' },
  { label: 'Preço: maior para o menor', value: 'price-desc' },
];
